import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ViewIcon extends BaseIcon {
    getChildren = () => [<path
        fill={this.getColor()}
        d='M6,4H5v6h1V4z M8,7H7v3h1V7z M9,12l0,2H7v-2L9,12z M13,15L3,15l0-1h10V15z M10,10H9V6h1V10z M14,12H2  c-0.6,0-1-0.4-1-1V3c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1v8C15,11.6,14.6,12,14,12z' />]
    getViewBox = () => '0 0 16 16'
}